import React from 'react';

interface IconProps {
    width?: number;
    height?: number;
    color?: string;
    onClick?: () => void;
}

const DialogCloseIcon: React.FC<IconProps> = ({
    width = 15,
    height = 15,
    color = "rgb(69, 110, 141)",
    onClick = () => {}
}) => {
    return (
        <svg
            fill={color}
            height={height}
            width={width}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            onClick={onClick}
        >
            <g>
                <polygon points="512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 512,452.922 315.076,256" />
            </g>
        </svg>
    );
};

export default DialogCloseIcon;